import React, { useEffect, useState } from 'react';
import '../../componentsStyling/ContentStyling.css';
import { DataGrid } from "@mui/x-data-grid";
import EditStudent from './EditStudent.js';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useStudentApis } from '../../apis/StudentAPIs.js';
import { useUserApis } from '../../apis/UsersAPIs.js';
import AddStudent from './AddStudent.js';
import CircularProgress from '@mui/material/CircularProgress';
import AddUser from '../users/AddUser.js';
import SearchBar from '../general/SearchBar.js';
import { handleCSVUpload } from '../../utils/csvImportHandler';
import useWindowSize from '../../utils/windowSize.js';



function Students() {
    const { checkStudentIdExists, fetchStudents, deleteStudent, updateStudent, addStudent } = useStudentApis();
    const { addUser } = useUserApis();
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [open, setOpen] = useState(false);
    const [studentDetailsDialogOpen, setStudentDetailsDialogOpen] = useState(false);
    const [addStudentDialogOpen, setAddStudentDialogOpen] = useState(false);
    const [addUserDialogOpen, setAddUserDialogOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [newUserData, setNewUserData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadStudents();
    }, []);

    useEffect(() => {
        const lowerCaseSearch = searchTerm.toLowerCase();
        setFilteredStudents(
            students.filter(
                (student) =>
                    (student.firstName && student.firstName.toLowerCase().includes(lowerCaseSearch)) ||
                    (student.lastName && student.lastName.toLowerCase().includes(lowerCaseSearch)) ||
                    (student.email && student.email.toLowerCase().includes(lowerCaseSearch)) ||
                    (student.phoneNumber && student.phoneNumber.toString().includes(lowerCaseSearch)) ||
                    (student.studentId && student.studentId.toString().includes(lowerCaseSearch))
            )
        );
    }, [searchTerm, students]);

    const loadStudents = async () => {
        setLoading(true);
        try {
            const studentsWithId = await fetchStudents();
            setStudents(studentsWithId);
            setFilteredStudents(studentsWithId);
        } catch (err) {
            console.error("Error loading students:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
    };

    const onDelClick = (event, url) => {
        event.stopPropagation();
        if (window.confirm("Are you sure you want to delete this student?")) {
            deleteStudent(url).then(success => {
                if (success) {
                    loadStudents();
                    setOpen(true);
                } else {
                    alert('Something went wrong!');
                }
            });
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRowClick = (params) => {
        setSelectedRowData(params.row);
        setStudentDetailsDialogOpen(true);
    };

    const handleStudentDetailsDialogClose = () => {
        setStudentDetailsDialogOpen(false);
        setSelectedRowData(null);
    };

    const handleAddStudentDialogOpen = () => {
        setAddStudentDialogOpen(true);
    };

    const handleAddStudentDialogClose = () => {
        setAddStudentDialogOpen(false);
    };

    const handleAddUserDialogOpen = () => {
        setAddUserDialogOpen(true);
    };

    const handleAddUserDialogClose = () => {
        setAddUserDialogOpen(false);
    };

    const handleAddStudent = async (newStudent) => {
        const success = await addStudent(newStudent);
        if (success) {
            loadStudents();
            setAddStudentDialogOpen(false);
            return true;
        }
        return false;
    };

    const handleAddUser = async (newUser) => {
        try 
        {
            let result = await addUser(newUser);  // Call to create the user

            alert(result.message)

            if (result.success) {
                // Reload students and close dialog
                loadStudents();
                setAddUserDialogOpen(false);
                return true;
            }

        } catch (error) {
            console.error("Error adding user or updating student:", error);
            alert("Unexpected error occurred");
        }

        return false;
    };

    const handleAddUserClick = (student) => {
        setSelectedRowData(student.row);
        handleAddUserDialogOpen();
        const newUser = {
            username: student.row.firstName + '_' + student.row.lastName,  // Autofill username with student's first name
            password: '',  // Empty password field
            role: 'STUDENT',  // Default to student role
            studentId: student.row.studentId,  // Autofill student ID
        };
        setNewUserData(newUser);  // Set the newUserData state with the pre-filled data
    };

    const columnDefs = [
        { field: 'studentId', headerName: 'Student ID', width: 150 },
        { field: 'firstName', headerName: 'First Name', width: 150 },
        { field: 'lastName', headerName: 'Last Name', width: 150 },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'phoneNumber', headerName: 'Phone', width: 150 },
        {
            field: '_links.self.href',
            headerName: '',
            sortable: false,
            filterable: false,
            renderCell: row => (
                <div onClick={(event) => event.stopPropagation()}>
                    <EditStudent
                        data={row}
                        updateStudent={(student, link) => updateStudent(student, link).then(success => {
                            if (success) loadStudents();
                            else alert('Something went wrong!');
                        })}
                    />
                </div>
            )
        },
        {
            field: '_links.student.href',
            headerName: '',
            sortable: false,
            filterable: false,
            renderCell: (row) => (
                <IconButton onClick={(event) => onDelClick(event, row.id)}>
                    <DeleteIcon color="error" />
                </IconButton>
            )
        },
        {
            field: 'addUser',
            headerName: 'Create User',
            sortable: false,
            filterable: false,
            renderCell: (row) => {
                // Check if activationStatus is true other wise don't give the option
                if (row.row.activationStatus === true) {
                    return null;
                }
                return (
                    <IconButton
                        onClick={(event) => {
                            event.stopPropagation();
                            handleAddUserClick(row);
                        }}
                    >
                        <AddCircleIcon style={{ color: 'green' }} />
                    </IconButton>
                );
            },
            width: 100
        },
    ];

    // Calculate dynamic table height for desktop/laptop, accounting for components above
    const { width, height } = useWindowSize();
    const isSmallScreen = width < 900;
    // Header: ~85px, Title container: ~80px, SearchBar: ~60px, Padding: ~50px
    // Reduced subtraction to make tables extend down and push footer below viewport
    const tableHeight = !isSmallScreen 
        ? Math.max(400, height - 225) // Minimum 400px, subtract only components above table
        : 600; // Keep fixed height for mobile

    if (loading) {
        return (
            <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </div>
        );
    }
    return (
        <div>
            <div id="titleContainer">

                <button className="add-button" onClick={handleAddStudentDialogOpen}>Add</button>
                
                <h1 style={{margin:'5px'}}>Students</h1>

                <button className='import-button'>
                    <input
                        type="file"
                        accept=".csv"
                        id="csv-upload"
                        style={{ display: "none" }}
                        onChange={(e) => handleCSVUpload(e, loadStudents, alert, checkStudentIdExists, addStudent)}
                    />

                    <label htmlFor="csv-upload">
                        <span>Import CSV</span>
                    </label>
                </button>

            </div>


            <SearchBar onSearch={handleSearch} />

            <div className="table-container" >
                <div className="dataGridContainer" style={{ width: '100%', maxWidth: 'min-content', height: `${tableHeight}px` }}>
                    <DataGrid
                        rows={filteredStudents}
                        columns={columnDefs}
                        disableSelectionOnClick={true}
                        getRowId={row => row._links.self.href}
                        rowHeight={80}
                        onRowClick={handleRowClick}
                    />
                </div>
            </div>

            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Student deleted successfully"
            />

            {/* Student Details Dialog */}
            <Dialog open={studentDetailsDialogOpen} onClose={handleStudentDetailsDialogClose} maxWidth="md" fullWidth>
                <DialogTitle>Student Details</DialogTitle>
                <DialogContent>
                    {selectedRowData && (
                        <div>
                            {Object.entries(selectedRowData)
                                .filter(([key]) => key !== '_links')
                                .map(([key, value]) => (
                                    <div key={key} style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
                                        <strong style={{ textTransform: 'capitalize', marginRight: '10px' }}>
                                            {key.replace(/([A-Z])/g, ' $1')}:
                                        </strong>
                                        <span style={{ wordBreak: 'break-word', textAlign: 'right' }}>
                {value ? value.toString() : 'N/A'}
            </span>
                                    </div>
                                ))}

                        </div>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleStudentDetailsDialogClose}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* Add Student Dialog */}
            <AddStudent
                open={addStudentDialogOpen}
                onClose={handleAddStudentDialogClose}
                onSave={handleAddStudent}
            />

            {/* Add User Dialog */}
            <AddUser
                open={addUserDialogOpen}
                onClose={handleAddUserDialogClose}
                onSave={handleAddUser}  // Use handleAddUser for saving user
                userRole={sessionStorage.getItem('userRole')}
                newUserData={newUserData}
                setNewUserData={setNewUserData}
            />
        </div>
    );
}

export default Students;
